import React from "react";
import { API_ROOT } from "../../../../baseUrls";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import {
  getMindfile,
  getCurrentUserMindfiles,
} from "../../../../state/actions/getDataActions";
import { Box, Typography, Button } from "@mui/material";

const useStyles = makeStyles(() => ({
  button: {
    marginRight: 12,
    marginTop: 16,
  },
}));

function RespondInvitation ({
  name,
  invitationId,
  close,
  mindfile,
  user,
  getMindfile,
  getCurrentUserMindfiles,
}) {
  const classes = useStyles();

  const acceptInvitation = () => {
    const responseUrl = new URL(
      `${API_ROOT}/mindfiles/${mindfile.id}/respond/${invitationId}`
    );
    const queryParams = {
      choice: "accept",
      authenticity_token: user.authenticity_token,
    };
    Object.keys(queryParams).forEach(key =>
      responseUrl.searchParams.append(key, queryParams[key])
    );

    fetch(responseUrl, {
      method: "GET",
      credentials: "include",
    })
      .then(resp => resp.text())
      .then(text => {
        getMindfile(mindfile.id);
        getCurrentUserMindfiles();
      })
      .catch(error => console.error(error))
      .finally(close);
  };

  const declineInvitation = () => {
    const responseUrl = new URL(
      `${API_ROOT}/mindfiles/${mindfile.id}/respond/${invitationId}`
    );
    const queryParams = {
      choice: "decline",
      authenticity_token: user.authenticity_token,
    };
    Object.keys(queryParams).forEach(key =>
      responseUrl.searchParams.append(key, queryParams[key])
    );

    fetch(responseUrl, {
      method: "GET",
      credentials: "include",
    })
      .then(resp => resp.text())
      .then(() => getMindfile(mindfile.id))
      .catch(error => console.error(error))
      .finally(close);
  };

  return (
    <Box id="inviteRespondDialog">
      <Typography variant="h6">Respond to this invitation</Typography>
      <Box mt={3} />
      <Typography>
        You've been invited to join the <b>{name}</b> mindfile. It's a
        multi-user mindfile, authored by a collaboration of users.
      </Typography>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={acceptInvitation}
      >
        Accept
      </Button>
      <Button
        className={classes.button}
        variant="contained"
        onClick={declineInvitation}
      >
        Decline
      </Button>
      <Button className={classes.button} variant="contained" onClick={close}>
        Cancel
      </Button>
    </Box>
  );
};

const mapStateToProps = state => ({
  mindfile: state.mindfile,
  user: state.auth,
});

const mapDispatchToProps = {
  getMindfile,
  getCurrentUserMindfiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RespondInvitation);
